import moment from "moment"
import { Accordion, Button, Card, Col, Row, Table } from "react-bootstrap"

function HistoricExpCMedicamentos({data}){
    //console.log(data)
    return(
        data.length > 0 ?
        <Row>
            <Col>
                <Accordion>
                    {
                        data.map((item, i)=>(
                            <Card key={i}>
                                <Card.Header className="p-0">
                                    <Accordion.Toggle as={Button} variant="link" eventKey={item.id}>{moment(item.dateCreated, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm")}</Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey={item.id}>
                                <Card.Body>
                                    {
                                        <Table size="sm" className="m-0">
                                            <thead>
                                                <tr>
                                                    <th>Medicamento</th>
                                                    <th>Días</th>
                                                    <th>Horas</th>
                                                    <th>Indicaciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    item.medicamentoList.map((med, index)=>(
                                                        <tr key={index}>
                                                            <td>{med.medicamento}</td>
                                                            <td>{med.dias}</td>
                                                            <td>{med.horas}</td>
                                                            <td>{med.indicaciones}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    }
                                </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        ))
                    }
                    </Accordion>
            </Col>
        </Row>
        :
        <Row>
            <Col>No existe historial</Col>
        </Row>
    )
}

export default HistoricExpCMedicamentos